 /**
 * v-hasPermi 操作权限处理
 * Copyright (c) 2019 ruoyi
 */
 
 import store from '@/store'

 export default {
   inserted(el, binding, vnode) {
     const { value } = binding
     const all_permission = "*:*:*";
     const permissions = store.state.user.permissions
 
     if (value && value instanceof Array && value.length > 0) {
       const permissionFlag = value
 
       const hasPermissions = permissions.some(permission => {
         return all_permission === permission || permissionFlag.includes(permission)
       })
 
       if (!hasPermissions) {
        // 实现按钮禁用
        el.disabled = true

        // 增加 elementUI 的禁用样式类
        el.classList.add('is-disabled')
        
        // 设置样式，禁止点击, 解决switch,仅设置样式无效的问题
        el.style = 'pointer-events: none;';
       }
     } else {
       throw new Error(`请设置操作权限标签值`)
     }
   }
 }
 